"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/ManualIcon.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ManualIcon = function ManualIcon(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 208.2 208.2"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Manual Transmission Icon"), _react2.default.createElement("g", {
    className: "manual-icon",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("g", {
    className: "circle",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "outer-circle",
    d: "M104.1 0a104.1 104.1 0 1 0 104.1 104.1A104.28 104.28 0 0 0 104.1 0zm0 198.7a94.6 94.6 0 1 1 94.6-94.6 94.6 94.6 0 0 1-94.6 94.6z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "inner-circle",
    d: "M104.1 18.5a85.6 85.6 0 1 0 85.6 85.6 85.63 85.63 0 0 0-85.6-85.6zm0 168.4a82.8 82.8 0 1 1 82.8-82.8 83 83 0 0 1-82.8 82.8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: undefined
  })), _react2.default.createElement("path", {
    className: "manual",
    d: "M140.8 140.3v-27.9c0-3.6-2.3-6.5-4.6-8.3 2.3-1.8 4.6-4.7 4.6-8.3V67.9a9.53 9.53 0 1 0-5.1-.3v24.7c0 3.2-.3 5.6-1.9 7.1-1.3 1.2-3.4 1.8-6.5 1.8h-20.9V67.8a9.5 9.5 0 1 0-5.1 0v33.5H77.9c-5 0-5.9-3.4-5.9-8.9V67.8a9.5 9.5 0 0 0-5.1-18.3 9.43 9.43 0 0 0 .1 18.2v28c0 3.6 2.3 6.5 4.6 8.3-2.3 1.8-4.6 4.7-4.6 8.3v28a9.47 9.47 0 1 0 11.9 9.2 9.42 9.42 0 0 0-6.9-9.1v-24.5c0-5.5 1-8.9 5.9-8.9h23.4v33.4a9.5 9.5 0 1 0 5.1 0V107h20.9c3.1-.1 5.2.5 6.5 1.8 1.5 1.5 1.9 3.9 1.9 7.1v24.7a9.41 9.41 0 1 0 5.1-.3zm-6-81.6a4 4 0 1 1 4 4 4 4 0 0 1-4-4zm4 94.8a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm-30.9-4a4 4 0 1 1-4-4 4 4 0 0 1 4 4zm-8-90.8a4 4 0 1 1 4 4 4 4 0 0 1-4-4zm-26.5 90.8a4 4 0 1 1-4-4 4 4 0 0 1 4 4zm0-90.8a4 4 0 1 1-4-4 4 4 0 0 1 4 4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: undefined
  })));
};
exports.default = ManualIcon;